export default {
      id: "i-download-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-download",
      toString: function () {
        return this.url;
      }
    }